module.exports = __webpack_public_path__ + "img/medical_teams_black.87532897.svg";